import React, { useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import { FaBars, FaUserCircle, FaSignOutAlt } from 'react-icons/fa';
import { AuthContext } from '../contexts/AuthContext';
import logo from '../assets/logo.png';
import './Topbar.css';

const Topbar = ({ onToggleSidebar, isSidebarCollapsed, isMobile, showMobileOverlay, hamburgerRef }) => {
  const { setLoggedIn } = useContext(AuthContext);
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState({ username: '', email: '' });
  const [loadingUser, setLoadingUser] = useState(true);

  // Determine backend URL based on environment
  const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';

  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        setLoadingUser(true);
        const response = await fetch(`${backendUrl}/tms/api/user-info`, {
          method: 'GET',
          credentials: 'include',
        });

        if (response.ok) {
          const data = await response.json();
          setUserInfo({ username: data.username, email: data.email });
        } else if (response.status === 401) {
          // User not logged in
          console.warn('User not logged in');
          setUserInfo({ username: 'Guest', email: '' });
        } else {
          console.error('Failed to fetch user info', response.status);
        }
      } catch (error) {
        console.error('Error fetching user info:', error);
      } finally {
        setLoadingUser(false);
      }
    };

    fetchUserInfo();
  }, [backendUrl]);

  const handleLogout = async () => {
    try {
      await fetch(`${backendUrl}/tms/api/logout`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
      });
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      localStorage.removeItem('token');
      setLoggedIn(false);
      navigate('/tms/login');
    }
  };

  return (
    <div className="topbar">
      <div className="topbar-left">
        <button
          ref={hamburgerRef}
          className="hamburger-menu"
          onClick={onToggleSidebar}
          aria-label={
            isMobile
              ? showMobileOverlay
                ? 'Close navigation menu'
                : 'Open navigation menu'
              : isSidebarCollapsed
              ? 'Expand sidebar'
              : 'Collapse sidebar'
          }
          aria-expanded={isMobile ? showMobileOverlay : !isSidebarCollapsed}
          aria-controls="main-sidebar"
        >
          <FaBars aria-hidden="true" />
        </button>
        <div className="topbar-logo">
          <img src={logo} alt="Freight Ops TMS" className="logo-image" />
        </div>
      </div>

      <div className="topbar-right">
        <Dropdown align="end">
          <Dropdown.Toggle variant="link" id="user-dropdown" className="user-dropdown-toggle" aria-label="User menu">
            <FaUserCircle className="user-icon" />
          </Dropdown.Toggle>

          <Dropdown.Menu className="user-dropdown-menu">
            <Dropdown.Header className="dropdown-header">
              <div className="user-info">
                <FaUserCircle className="user-avatar" />
                <div className="user-details">
                  <div className="user-name">
                    {loadingUser ? 'Loading...' : userInfo.username || 'Guest'}
                  </div>
                {/* <div className="user-email">{loadingUser ? '' : userInfo.email}</div> */}
                </div>
              </div>
            </Dropdown.Header>
            <Dropdown.Divider />
            <Dropdown.Item onClick={handleLogout} className="logout-item">
              <FaSignOutAlt className="dropdown-icon" />
              Logout
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  );
};

export default Topbar;
